import http from "infra/http";
import { useQuery } from "react-query";

function useParametrosDiaVencimento(tenant?: string) {
  const url = `v1/parametros-cobranca/${tenant}/dia-vencimento`;
  return useQuery(
    url,
    async () => {
      const { data } = await http.get<{ diaVencimento: number }>(url);
      return data;
    },
    {
      enabled: !!tenant,
    }
  );
}

export default useParametrosDiaVencimento;
